import ButtonBase from "components/shared/ButtonBase";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { renderHello } from "helpers/utils";
import type { KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";

interface AuthLoginProps {
    username: string;
    error: boolean;
    errorMessage: string;
    isReadyToConnect: boolean;
    isLoading: boolean;
    validateMFA: () => void;
    setOTPCode: (code: string) => void;
}

const AuthLoginMFA = ({
    username,
    error,
    errorMessage,
    isReadyToConnect,
    isLoading,
    validateMFA,
    setOTPCode,
}: AuthLoginProps) => {
    const [t] = useTranslation();

    const handleLoginFromPwdField = (e: KeyboardEvent<HTMLInputElement>) =>
        e.key == "Enter" && isReadyToConnect && validateMFA();

    return (
        <>
            {(username == "" && <h1>{t("LogIn.LogIn")}</h1>) || (
                <h1 className="trans-slide-in">
                    {t(renderHello())} {username}
                </h1>
            )}
            <div className="login-left-container-fields trans-slide-in" key={"login"}>
                <div className="login-left-container-field">
                    <div className="login-left-container-subtext">{t("Settings.AccountMFA")}</div>
                    <StyledTextField
                        placeholder="000000"
                        onChange={(ev) => setOTPCode(ev.target.value)}
                        onKeyDown={handleLoginFromPwdField}
                    />
                </div>
                <ButtonBase
                    variant="contained"
                    styles={{ borderRadius: "4px" }}
                    disabled={!isReadyToConnect}
                    loading={isLoading}
                    onClick={validateMFA}
                >
                    {t("LogIn.LogIn")}
                </ButtonBase>
                {error && <div className="login-left-container-error">{errorMessage || t("LogIn.Error")}</div>}
            </div>
        </>
    );
};

export default AuthLoginMFA;
